import React, { useEffect } from 'react';
import { Form, Select, Input, FormModal } from 'components';
import { Col, Row } from 'antd';

interface RejectBrandModalProps {
  form: any;
  open: boolean;
  onSubmit: () => void;
  onCancel: () => void;
  rejectionReasons: { label: string; value: string }[];
}

export const RejectBrandModal: React.FC<RejectBrandModalProps> = ({
  form,
  open,
  onSubmit,
  onCancel,
  rejectionReasons,
}) => {
  useEffect(() => {
    if (open) {
      form.resetFields();
    }
  }, [form, open]);

  return (
    <FormModal
      form={form}
      title="Reject Brand"
      width={400}
      open={open}
      onSubmit={onSubmit}
      onCancel={onCancel}
      okText="Reject"
      okButtonProps={{ danger: true }}
    >
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Form.Item
            name="reason"
            label="Reason*"
            rules={[{ required: true, message: 'Please select a rejection reason' }]}
          >
            <Select size={'large'} options={rejectionReasons} />
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item name="additionalInformation" label="Additional Information">
            <Input.TextArea rows={4} />
          </Form.Item>
        </Col>
      </Row>
    </FormModal>
  );
};
